// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","views":"App_views__7IQ6Y","type-text-child":"App_type-text-child__aYMdG"};